import { render } from "./Mailing.vue?vue&type=template&id=09db0d65&scoped=true"
import script from "./Mailing.vue?vue&type=script&lang=js"
export * from "./Mailing.vue?vue&type=script&lang=js"

import "./Mailing.vue?vue&type=style&index=0&id=09db0d65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09db0d65"]])

export default __exports__